import { render } from "./ServiceFbDone.vue?vue&type=template&id=3937c381"
import script from "./ServiceFbDone.vue?vue&type=script&lang=js"
export * from "./ServiceFbDone.vue?vue&type=script&lang=js"

import "./ServiceFbDone.vue?vue&type=style&index=0&id=3937c381&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__